/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySystemTag
 */
export interface FacilitySystemTag {
    /**
     * 
     */
    category: FacilitySystemTagCategoryEnum;
    /**
     * 
     */
    label: string;
}


/**
 * @export
 */
export const FacilitySystemTagCategoryEnum = {
    UsState: 'US_STATE',
    FacilityType: 'FACILITY_TYPE',
    Region: 'REGION',
} as const;
export type FacilitySystemTagCategoryEnum = typeof FacilitySystemTagCategoryEnum[keyof typeof FacilitySystemTagCategoryEnum];


/**
 * Check if a given object implements the FacilitySystemTag interface.
 */
export function instanceOfFacilitySystemTag(value: object): value is FacilitySystemTag {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FacilitySystemTagFromJSON(json: any): FacilitySystemTag {
    return FacilitySystemTagFromJSONTyped(json, false);
}

export function FacilitySystemTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySystemTag {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'],
        'label': json['label'],
    };
}

export function FacilitySystemTagToJSON(json: any): FacilitySystemTag {
    return FacilitySystemTagToJSONTyped(json, false);
}

export function FacilitySystemTagToJSONTyped(value?: FacilitySystemTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'label': value['label'],
    };
}

